import ManufacturerDetail from './ManufacturerDetail';

export default ManufacturerDetail;



// WEBPACK FOOTER //
// ./src/scenes/Manufacturers/ManufacturerDetail/index.ts